import { createFileRoute } from '@tanstack/react-router';
import FinanceReports from '../accounting/finance-reports';
export const Route = createFileRoute('/accounting/reports/$reportId')({
  component: FinanceReports,
});
